import { Button, Checkbox, IconButton, FormControlLabel, Typography, Modal } from '@mui/material'
import { CloseRounded } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'
import { styled } from '@mui/material/styles'
import { useCallback, useState } from 'react'
import { privacyPolicy } from '../../constant/Constant'
import Scrollbar from '../../control/Scrollbar'
import { usePolicyCore } from '../../util/policyCore'

export type ShowDialogProps = {
    show: boolean
    onAcceptPolicy?: () => void
    onClose?: () => void
}

const PrivacyPolicyDialog = (props: ShowDialogProps) => {
    const classes = useStyles()
    const { onPolicyLinkClicked, policyLinkCssClass } = usePolicyCore()
    const [accept, setAccept] = useState(false)

    const onAcceptClicked = useCallback(() => {
        setAccept(false)
        props.onAcceptPolicy?.()
    }, [])

    const onCloseClicked = useCallback(() => {
        setAccept(false)
        props.onClose?.()
    }, [])

    const style = {
        position: 'absolute' as 'absolute',
        background: 'white',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 40px)',
        maxWidth: '500px',
        maxHeight: '660px',
        wordBreak: 'break-word' as 'break-word',
        whiteSpace: 'pre-line' as 'pre',
        borderRadius: '5px',
    }

    return (
        <Modal open={props.show}>
            <div style={style} className={classes.modalShadow}>
                <StyledDivButtonRight>
                    <IconButton
                        size="large"
                        style={{
                            color: '#2780F9',
                            position: 'absolute',
                            right: '0px',
                        }}
                        onClick={onCloseClicked}
                    >
                        <CloseRounded style={{ width: '24px', height: '24px' }} />
                    </IconButton>
                </StyledDivButtonRight>
                <StyledDivRow>
                    <h2 style={{ color: '#2780F9' }}>{privacyPolicy.title}</h2>
                </StyledDivRow>
                <div style={{ margin: '24px', maxHeight: '350px', textIndent: '15px' }}>
                    <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                        <p>{privacyPolicy.content1}</p>
                        <p>{privacyPolicy.content2}</p>
                        <p>{privacyPolicy.content3}</p>
                        <span
                            className={policyLinkCssClass.policyLink}
                            onClick={onPolicyLinkClicked}
                            style={{ color: '#2780F9' }}
                        >
                            {privacyPolicy.txtHyperlink}
                        </span>
                    </Scrollbar>
                </div>
                <StyledDivRow>
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{
                                    color: '#2780F9',
                                    '&.Mui-checked': {
                                        color: '#2780F9',
                                    },
                                }}
                                value={accept}
                                onLoad={() => setAccept(false)}
                                onChange={(e, checked) => setAccept(checked)}
                            />
                        }
                        label={
                            <Typography className={classes.formControlLabel}>{privacyPolicy.acceptCheckbox}</Typography>
                        }
                    />
                </StyledDivRow>
                <StyledDivRow>
                    <Button
                        classes={{ root: classes.button }}
                        size="large"
                        variant="contained"
                        color="primary"
                        disabled={!accept}
                        onClick={onAcceptClicked}
                    >
                        {privacyPolicy.acceptButton}
                    </Button>
                </StyledDivRow>
            </div>
        </Modal>
    )
}

const useStyles = makeStyles((theme) => ({
    button: {
        width: '250px',
        fontSize: '14px !important',
        transform: 'translateX(-50%)',
        left: '50%',
    },
    icon: {
        fontSize: '70px !important',
        color: '#318AF14D',
        opacity: 30,
    },
    checkbox: {
        display: 'inline-block',
        height: '20px',
        width: '20px',
        background: '#fff',
        border: '2px #ddd solid',
        marginRight: '4px',
    },
    checkboxChecked: {
        borderColor: '#2780F9',
        background: '#2780F9',
    },
    formControlLabel: {
        fontSize: '14px !important',
    },
    modalShadow: {
        boxShadow: '3px 3px 7px 0px rgba(0,0,0,0.25)',
    },
}))

const StyledDivRow = styled('div')(({ theme }) => ({
    display: 'flex',
    // width: 'calc(100% - 32px)',
    margin: '16px 24px',
}))

const StyledDivButtonRight = styled('div')(({ theme }) => ({
    width: 'calc(100% - 32px)',
    margin: '16px',
    position: 'relative',
}))

export default PrivacyPolicyDialog
